<template><svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14">
    <g fill="none" stroke="currentColor" stroke-linejoin="round" stroke-linecap="round" stroke-width="1.5">
        <path d="M403.53,235.305a3.775,3.775,0,1,0-3.775-3.775A3.776,3.776,0,0,0,403.53,235.305Z"
              transform="translate(-398.91 -224.491)"/>
        <path d="M417.03,235.305a3.775,3.775,0,1,0-3.775-3.775A3.776,3.776,0,0,0,417.03,235.305Z"
              transform="translate(-407.65 -224.491)"/>
    </g>
</svg>
</template>